import { createFileRoute } from "@tanstack/react-router";
import { CommandCatalogListPage } from "../../../components/system/CommandCatalogListPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/command-catalog/")({
  beforeLoad: requireSuperAdmin(),
  component: CommandCatalogListPage,
});
